module.exports = __webpack_public_path__ + "static/media/ParvoALERT_new_logo.257d1ff4.png";